<template>
    <div id="app">
        <div class="refund" v-if='!network'>
            <div class="img"></div>
            <div class="refresh">请检查网络连接</div>
            <div class="btn" @click="onRefresh">刷新</div>
        </div>
        <keep-alive :include="cachedInclude" :exclude="cachedExclude">
            <router-view></router-view>
        </keep-alive>
        <!-- <router-view/> -->
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: {
        ...mapState({
            cachedInclude: state => state.cachedInclude,
            cachedExclude: state => state.cachedExclude,
            network: state => state.network
        })
    },
    data () {
        return {
            dataImg: require('@/assets/img/b2b/disnet.png')
        }
    },
    methods: {
        // 通过跳转一个空页面再返回的方式实现刷新当前页面的目的
        onRefresh () {
            this.$route.meta.isPage = true
            this.$router.replace('/b2b/common/refresh')
        }
    }
}
</script>

<style>
html,
body {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    height: 100%;
    background: #f5f5f5;
}
.refund {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #ffffff;
    z-index: 9999;
    overflow: hidden;
}

.refund .img{
    width: 280px;
    height: 280px;
    margin: 120px auto 32px;
}

.refund .refresh{
    text-align: center;
    font-size: 28px;
    color: #999;
}

.refund .btn{
    width: 200px;
    margin: 30px auto;
    height: 60px;
    line-height: 60px;
    color: #fff;
    border-radius: 40px;
    font-size: 26px;
    text-align: center;
    background: #FF7A45;
}
</style>
